export default __webpack_public_path__ + "static/media/NITIN BHARATIA.c9a40bc1.jpg";